import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import './ErrorBoundary.css';

const InsightsErrorBoundary = ({ children, onRetry }) => {
  // Custom fallback UI for insights widget
  const insightsFallback = (error, retryHandler) => (
    <div className="insights-widget">
      <div className="insights-card">
        <div className="insights-error-boundary compact">
          <div className="error-boundary-content">
            <div className="error-icon">📊</div>
            <h3 className="error-title">Insights Unavailable</h3>
            <p className="error-message">
              Unable to load class insights. This could be due to a temporary 
              connection issue or data processing error.
            </p>
            <button 
              onClick={retryHandler}
              className="error-retry-btn"
            >
              Reload Insights
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ErrorBoundary
      title="Dashboard Insights Error"
      message="There was a problem loading the insights widget. Please try refreshing."
      fallback={insightsFallback}
      onRetry={onRetry}
    >
      {children}
    </ErrorBoundary>
  );
};

export default InsightsErrorBoundary;